module.exports = __webpack_public_path__ + "cement/img/组 23180@2x(2).09f48f5f.png";